import { ICurrency } from '../../../libraries/currencies';
import { MeansCash } from '../../../libraries/transactions';

export interface BankTransactionDenom {
  cid: number;
  currency: ICurrency;
  cindex: number;
  value: number;
  received: number;
  dispensed: number;
}

export interface BankCurrTableColumn {
  cindex: number;
  quantity: number;
  value: number;
  amount: number;
}

export interface BankTransactionCurrencyInfo {
  currency: ICurrency;
  totalQty: number;
  totalAmount: number;
  denominations: BankTransactionDenom[];
  columns: BankCurrTableColumn[];
  received?: boolean;
  dispensed?: boolean;
}

export const processBankTransactionData = (
  transactionData: { cashIn?: MeansCash[] },
  currencies: ICurrency[]
): BankTransactionCurrencyInfo[] => {
  const transactionCurrencies: BankTransactionCurrencyInfo[] = [];

  // Ensure each mc has a cid (default to first currency if missing)
  transactionData.cashIn?.forEach(mc => {
    if (mc.cid === undefined && currencies.length > 0) mc.cid = currencies[0].cid;
  });

  currencies.forEach(currency => {
    const mcForCurrency = transactionData.cashIn?.filter(mc => mc.cid === currency.cid) || [];

    mcForCurrency.forEach(mc => {
      const denom = currency.denominations.find(d => d.index === mc.index);
      if (!denom) return;

      // Determine received/dispensed
      const isReceived = mc.origin === 0 || mc.origin / 10 === 1 || mc.origin / 10 === 2;
      const isDispensed = mc.destiny === 0;

      if (!isReceived && !isDispensed) return;

      const transDenom: BankTransactionDenom = {
        cid: currency.cid,
        currency,
        cindex: denom.index,
        value: denom.value,
        received: isReceived ? mc.quantity ?? 0 : 0,
        dispensed: isDispensed ? mc.quantity ?? 0 : 0
      };

      const quantity = transDenom.received + transDenom.dispensed;
      const amount = Number((quantity * denom.value * currency.factor).toFixed(2));

      const column: BankCurrTableColumn = {
        cindex: denom.index,
        quantity,
        value: denom.value * currency.factor,
        amount
      };

      transactionCurrencies.push({
        currency,
        totalQty: quantity,
        totalAmount: amount,
        denominations: [transDenom],
        columns: [column],
        received: transDenom.received > 0,
        dispensed: transDenom.dispensed > 0
      });
    });
  });

  return transactionCurrencies;
};
